import { GlobalData } from "../Common/GlobalData";
import { ReportDateHelper, TemplateHelpers, ValueSwapHelper } from "../Common/KendoHelpers";
import { StockPickList } from "../Common/StockPickList";

export class OverboughtOversold {
    private static readonly GRID = '#grid';

    private static readonly FULL_FIELDS = [
        'fullOverboughtDate',
        'fullOverboughtValues',
        'fullOversoldDate',
        'fullOversoldValues',
        'fullCurrentPctK',
        'fullCurrentPctD',
    ];
    private static readonly SLOW_FIELDS = [
        'slowOverboughtDate',
        'slowOverboughtValues',
        'slowOversoldDate',
        'slowOversoldValues',
        'slowCurrentPctK',
        'slowCurrentPctD',
    ];
    private static readonly FAST_FIELDS = [
        'fastOverboughtDate',
        'fastOverboughtValues',
        'fastOversoldDate',
        'fastOversoldValues',
        'fastCurrentPctK',
        'fastCurrentPctD',
    ];

    constructor() {
        this.init();
    }

    private init() {
        $('[name=valueSwap').on('change', (event: any) => {
            const value = event.currentTarget.value;
            if (value == '0') {
                ValueSwapHelper.showHideFields(OverboughtOversold.GRID,
                    OverboughtOversold.FULL_FIELDS, OverboughtOversold.SLOW_FIELDS.concat(OverboughtOversold.FAST_FIELDS));
            } else if (value == '1') {
                ValueSwapHelper.showHideFields(OverboughtOversold.GRID,
                    OverboughtOversold.SLOW_FIELDS, OverboughtOversold.FULL_FIELDS.concat(OverboughtOversold.FAST_FIELDS));
            } else {
                ValueSwapHelper.showHideFields(OverboughtOversold.GRID,
                    OverboughtOversold.FAST_FIELDS, OverboughtOversold.FULL_FIELDS.concat(OverboughtOversold.SLOW_FIELDS));
            }
        });

        const stockPickList = new StockPickList(OverboughtOversold.GRID,
            GlobalData.URL_SUFFIX_TECHNICAL_REPORTS_OVERBOUGHT_AND_OVERSOLD);

        $(OverboughtOversold.GRID).kendoGrid({
            dataSource: new kendo.data.DataSource(stockPickList.getDataSourceOptions()),
            dataBound: () => {
                const data = $(OverboughtOversold.GRID).data('kendoGrid')!.dataSource.data();
                if (data && data.length > 0) {
                    ReportDateHelper.showReportDate(data[0].closingDate);
                }
            },
            height: 915,
            groupable: false,
            sortable: true,
            pageable: false,
            columns: [{
                field: 'symbol',
                title: 'Symbol',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'companyName',
                title: 'Company Name',
                width: '200px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12-left' },
                attributes: { 'class': 'table-cell grid-cell-left' },
            }, {
                field: 'fullOverboughtDate',
                title: 'Overbought<br>Date',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getFormattedDateTemplate('fullOverboughtDate')),
            }, {
                field: 'fullOverboughtValues',
                title: 'Overbought<br>%K, %D, Slope',
                width: '150px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'fullOversoldDate',
                title: 'Oversold<br>Date',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getFormattedDateTemplate('fullOversoldDate')),
            }, {
                field: 'fullOversoldValues',
                title: 'Oversold<br>%K, %D, Slope',
                width: '150px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'fullCurrentPctK',
                title: 'Current<br>% K',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:n2}',
            }, {
                field: 'fullCurrentPctD',
                title: 'Current<br>% D',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:n2}',
            }, {
                field: 'slowOverboughtDate',
                title: 'Overbought<br>Date',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getFormattedDateTemplate('slowOverboughtDate')),
            }, {
                field: 'slowOverboughtValues',
                title: 'Overbought<br>%K, %D, Slope',
                width: '150px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'slowOversoldDate',
                title: 'Oversold<br>Date',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getFormattedDateTemplate('slowOversoldDate')),
            }, {
                field: 'slowOversoldValues',
                title: 'Oversold<br>%K, %D, Slope',
                width: '150px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'slowCurrentPctK',
                title: 'Current<br>% K',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:n2}',
            }, {
                field: 'slowCurrentPctD',
                title: 'Current<br>% D',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:n2}',
            }, {
                field: 'fastOverboughtDate',
                title: 'Overbought<br>Date',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getFormattedDateTemplate('fastOverboughtDate')),
            }, {
                field: 'fastOverboughtValues',
                title: 'Overbought<br>%K, %D, Slope',
                width: '150px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'fastOversoldDate',
                title: 'Oversold<br>Date',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getFormattedDateTemplate('fastOversoldDate')),
            }, {
                field: 'fastOversoldValues',
                title: 'Oversold<br>%K, %D, Slope',
                width: '150px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'fastCurrentPctK',
                title: 'Current<br>% K',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:n2}',
            }, {
                field: 'fastCurrentPctD',
                title: 'Current<br>% D',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:n2}',
            }, {
                field: 'fullSlowFast',
                title: 'FSF STO<br>Chart',
                width: '60px',
                encoded: false,
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'stoMacdPmo',
                title: 'SMP<br>Chart',
                width: '60px',
                encoded: false,
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'closingDate',
                hidden: true,
            }]
        });

        ValueSwapHelper.showHideFields(OverboughtOversold.GRID,
            OverboughtOversold.FULL_FIELDS, OverboughtOversold.SLOW_FIELDS.concat(OverboughtOversold.FAST_FIELDS));
    }
}
